import hs_01 from './JPEG/hs_01.jpg';
import hs_02 from './JPEG/hs_02.jpg';
import hs_03 from './JPEG/hs_03.jpg';
import hs_04 from './JPEG/hs_04.jpg';
import hs_05 from './JPEG/hs_05.jpg';
import hs_06 from './JPEG/hs_06.jpg';
import hs_07 from './JPEG/hs_07.jpg';
import hs_08 from './JPEG/hs_08.jpg';
import hs_09 from './JPEG/hs_09.jpg';
import hs_10 from './JPEG/hs_10.jpg';
import hs_11 from './JPEG/hs_11.jpg';
import hs_12 from './JPEG/hs_12.jpg';
import hs_13 from './JPEG/hs_13.jpg';
import hs_14 from './JPEG/hs_14.jpg';
import hs_15 from './JPEG/hs_15.jpg';
import hs_16 from './JPEG/hs_16.jpg';
import hs_17 from './JPEG/hs_17.jpg';
import hs_18 from './JPEG/hs_18.jpg';
import hs_19 from './JPEG/hs_19.jpg';
import hs_20 from './JPEG/hs_20.jpg';
import hs_21 from './JPEG/hs_21.jpg';
import hs_23 from './JPEG/hs_23.jpg';
import hs_24 from './JPEG/hs_24.jpg';

const heads = [
  hs_01,
  hs_02,
  hs_03,
  hs_04,
  hs_05,
  hs_06,
  hs_07,
  hs_08,
  hs_09,
  hs_10,
  hs_11,
  hs_12,
  hs_13,
  hs_14,
  hs_15,
  hs_16,
  hs_17,
  hs_18,
  hs_19,
  hs_20,
  hs_21,
  hs_23,
  hs_24,
];

export default heads;



// WEBPACK FOOTER //
// ./src/images/heads/index.js